import React from 'react'

interface CheckCircleFilledIconProps {
  size?: number
  className?: string
}

export const CheckCircleFilledIcon: React.FC<CheckCircleFilledIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#check-circle-filled-clip)">
      <path
        d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.71 6.71L7.71 10.71C7.51 10.9 7.26 11 7 11C6.74 11 6.49 10.9 6.29 10.71L4.29 8.71C3.9 8.32 3.9 7.68 4.29 7.29C4.68 6.9 5.32 6.9 5.71 7.29L7 8.59L10.29 5.29C10.68 4.9 11.32 4.9 11.71 5.29C12.1 5.68 12.1 6.32 11.71 6.71Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="check-circle-filled-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
